const RemainingDisplay = ({index}) => {
    return (
        <div className='word' key={`remaining-${index}`}>
            {
                Array.from({ length: 5 }, (_, i) => (       
                    <div className='letterBox' state='unused' key={`letter-${i}`}></div>
                ))
            }       
        </div>
    )
}


export default RemainingDisplay;